import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, withModifiers as _withModifiers, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "w-1/12" }, null, -1)
const _hoisted_2 = { class: "w-3/4 text-black" }
const _hoisted_3 = { class: "w-1/12 text-right" }
const _hoisted_4 = { class: "bg-light-green p-2 rounded border border-light-green text-primary-blue font-bold" }
const _hoisted_5 = { class: "w-1/12 text-right text-light text-gray-7" }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "w-1/6" }, null, -1)
const _hoisted_8 = { class: "w-2/3 text-small text-black" }
const _hoisted_9 = { class: "w-1/12 text-right" }
const _hoisted_10 = { class: "p-2 rounded text-primary-blue border border-primary-blue font-bold" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("div", { class: "w-1/12 text-right text-light text-gray-7" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", {
      class: "flex flex-row justify-between items-center mb-8 cursor-pointer",
      onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.state.isExpanded = !_ctx.state.isExpanded), ["stop"]))
    }, [
      _hoisted_1,
      _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.supplier.supplier_name), 1),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.supplier.parcels_count), 1)
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("button", null, [
          _createElementVNode("span", {
            class: _normalizeClass(["icon text-big", _ctx.state.isExpanded ? 'icon-fold' : 'icon-drop'])
          }, null, 2)
        ])
      ])
    ]),
    (_ctx.state.isExpanded)
      ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.supplier.report_per_products, (product) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "flex flex-row justify-between items-center mb-8",
              key: product.id
            }, [
              _hoisted_7,
              _createElementVNode("div", _hoisted_8, _toDisplayString(product.product_name), 1),
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("span", _hoisted_10, _toDisplayString(product.parcels_count), 1)
              ]),
              _hoisted_11
            ]))
          }), 128))
        ]))
      : _createCommentVNode("", true)
  ]))
}